import React, { useState, useEffect } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const cardStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '140px',
  width: '210px',
  padding: '14px 18px 14px 22px',
  background: '#ffffff',
  border: '0.5px solid #E5E7EB',
  borderRadius: '10px',
  overflow: 'hidden',
};

const accentStyle = {
  position: 'absolute',
  left: 0, top: 0, bottom: 0,
  width: '3px',
  borderRadius: '10px 0 0 10px',
  background: '#1D9E75',
};

const tagStyle = {
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  color: '#9CA3AF',
  marginBottom: '8px',
};

const valueStyle = {
  fontSize: '22px',
  fontWeight: '500',
  color: '#0F6E56',
  lineHeight: '1',
  marginBottom: '6px',
};

const subStyle = {
  fontSize: '12px',
  color: '#6B7280',
};

const Card8 = ({ title }) => {
  const [valeurStock, setValeurStock] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchValeurStock = async () => {
      try {
        const response = await fetch(`${API}/stock_projete`);
        if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`);
        const data = await response.json();

        let montant = 0;
        if (Array.isArray(data) && data.length > 0) {
          const derniereLigne = data[data.length - 1];
          montant = parseFloat(derniereLigne.Montant ?? derniereLigne.montant ?? 0);
        } else if (data && typeof data === 'object') {
          montant = parseFloat(data.Montant ?? data.montant ?? 0);
        }

        setValeurStock(isNaN(montant) ? null : montant);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchValeurStock();
  }, []);

  const formattedValue = valeurStock !== null
    ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(valeurStock)
    : '—';

  return (
    <div style={cardStyle}>
      <div style={accentStyle} />
      <div style={tagStyle}>Valeur de stock m+12</div>
      <div style={valueStyle}>
        {loading ? 'Chargement…' : error ? 'Erreur' : formattedValue}
      </div>
      <div style={subStyle}>Projection 12 mois</div>
    </div>
  );
};

export default Card8;